export default __webpack_public_path__ + "static/media/Passwortschloss.6857c469.svg";